import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { SwapItem } from '@thd-olt-component-react/swap-item';
import { useFitCompatibility } from '../FitCompatibilityProvider';

/**
 * OptionsThatFitDrawer
 *
 * Renders the "Options That Fit" trigger + swap drawer by composing SwapItem.
 * SwapItem owns all drawer state, data fetching (packageSwapRecs), and product rendering.
 *
 * This component is intentionally feature-flagged:
 *   - It will NEVER render in production unless `enableOptionsThatFitDrawer` is explicitly
 *     set to `true` on the parent <FitCompatibility> component.
 *   - Rendered from FitCompatibilityRefrigeratorPIPWidget only when the fit result is
 *     DOES_NOT_FIT, so no fitResult check is required here.
 */
export const OptionsThatFitDrawer = () => {
  const { enableOptionsThatFitDrawer, itemId } = useFitCompatibility();

  if (!enableOptionsThatFitDrawer) return null;

  return (
    <div data-component="OptionsThatFitDrawer">
      <SwapItem
        itemId={itemId}
        onSwap={() => {}}
        customElement={(
          <Button
            variant="secondary"
            size="small"
            fullWidth
            data-testid="fit-compatibility-options-that-fit"
          >
            <span className="sui-whitespace-nowrap">Options That Fit</span>
          </Button>
        )}
      />
    </div>
  );
};

OptionsThatFitDrawer.displayName = 'OptionsThatFitDrawer';
OptionsThatFitDrawer.dataModel = SwapItem.dataModel;
